/* eslint-disable react/prop-types */
import React from 'react';
import { View, Grid, Flex, ListBox, Link, Item } from '@adobe/react-spectrum';
import AdminScreen from './Admin';

function Settings(props) {
  const { isAdmin, ims, setUserID } = props;
  return (
    <Grid
      areas={['sidebar content']}
      columns={['3fr', '1fr']}
      rows="auto"
      height="100%"
      gap="size-100"
    >
      <View gridArea="sidebar">
        <Flex direction="column" width="100%" gap="size-100">
          <View height="size-3600">
            <h1> Preferences</h1>
            <ListBox width="static-size-1200">
              <Item>
                <Link>
                  <a
                    href="https://author-p24737-e96352.adobeaemcloud.com/aem/start.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    AEM
                  </a>
                </Link>
              </Item>
              <Item>
                <Link>
                  <a
                    href="https://dentsumerkle.my.workfront.com/setup/projects"
                    target="_blank"
                    rel="noreferrer"
                  >
                    WORKFRONT
                  </a>
                </Link>
              </Item>
              <Item>
                <Link>
                  <a
                    href="https://creativecloud.adobe.com/cc/?locale=en"
                    target="_blank"
                    rel="noreferrer"
                  >
                    CC
                  </a>
                </Link>
              </Item>
            </ListBox>
          </View>
          {isAdmin ? (
            <View>
              <AdminScreen ims={ims} setUserID={setUserID} />
            </View>
          ) : null}
        </Flex>
      </View>
    </Grid>
  );
}

export default Settings;
